var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:[{ 'nav-open': _vm.$sidebar.showSidebar }]},[_c('notifications'),_c('side-bar',{attrs:{"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('template',{slot:"links"},[_c('sidebar-item',{staticClass:"user-profile-item",staticStyle:{"padding-bottom":"1rem"},attrs:{"link":{ name: _vm.title, icon: 'person_outline', path: '/portal/reader' }}},[_c('sidebar-item',{attrs:{"link":{ name: 'My Settings', icon: 'settings', path: '/portal/reader/my-settings' }}}),(_vm.isDoctor)?_c('sidebar-item',{attrs:{"link":{ name: 'Profile', icon: 'account_circle', path: '/portal/reader/doctor/profile' }}}):_vm._e()],1),_c('span',{staticClass:"user-role"},[_vm._v("Reader")]),_c('div',{staticStyle:{"border-bottom":"solid 1px rgba(180, 180, 180, 0.3)","margin-left":"1rem","margin-right":"1rem"}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Screenings',
          icon: 'visibility',
          path: '/portal/reader'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Available',
            icon: 'dashboard',
            path: '/portal/reader/screenings'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'On-Hold',
            icon: 'dashboard',
            path: '/portal/reader/Onhold'
          }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: 'Reports',
          icon: 'assignment_ind',
          path: '/portal/reader/reports'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Patients',
          icon: 'person',
          path: '/portal/reader/patients'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Work Up',
          icon: 'history',
          path: '/portal/reader'
        }}},[_c('sidebar-item',{attrs:{"link":{ name: 'Packages', icon: 'cloud_upload', path: '/portal/reader/packages' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'SiVIEW', icon: 'history', path: '/portal/reader/siview' }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: 'Admin',
          icon: 'emergency',
          path: '/portal/reader'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Providers',
            icon: 'emergency',
            path: '/portal/reader/doctors-list'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Dx Cards',
            icon: 'style',
            path: '/portal/reader/dxcards'
          }}})],1),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"http://help.globechek.com/support/home","target":"_blank"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#ffffff !important"}},[_vm._v("help")]),_c('p',{staticStyle:{"color":"white"}},[_vm._v("Help Desk")])])]),_c('sidebar-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"link":{
          name: 'Reference',
          icon: 'help_outline',
          path: '/portal/reader'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'ICD-10 Codes',
            icon: 'dashboard',
            path: '/portal/reader/disease-class'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'CPT Codes',
            icon: 'dashboard',
            path: '/portal/reader/procedure-code'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'HL7 FHIR',
            icon: 'dashboard',
            path: '/portal/reader/hl7-fhir'
          }}})],1),_c('sidebar-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"link":{
          name: 'Globe',
          icon: 'nature_people',
          path: '/portal/reader'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: '2-001',
            icon: 'language',
            path: '/portal/reader/administrative'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: '3-402',
            icon: 'language',
            path: '/portal/reader/administrative'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: '3-404',
            icon: 'language',
            path: '/portal/reader/administrative'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: '3-405',
            icon: 'language',
            path: '/portal/reader/administrative'
          }}})],1)],1)],2),_c('div',{staticClass:"main-panel",attrs:{"id":_vm.$route.path === '/portal/reader/evaluation' ? 'alt-color-panel' : ''}},[_c('top-navbar',{staticClass:"top-navbar"}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view',{style:(_vm.$route.path === '/portal/reader/evaluation' ? 'margin-top: 10px' : 'margin-top: 60px;'),attrs:{"align":"Center"}})],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }